module.exports = __webpack_public_path__ + "img/boss-arena.6ae58ace.png";